import { render, staticRenderFns } from "./ProfileEditPassword.vue?vue&type=template&id=44f80e04"
import script from "./ProfileEditPassword.vue?vue&type=script&lang=js"
export * from "./ProfileEditPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports